<template>
<div class="chapter">
<div class="inner_page">
<p class="h2-2"><i>contents</i></p>
<p class="toc"><a href="#/xhtml/Chapter01"><i>the</i> great gatsby party <img alt="" class="inline" height="18" src="images/toc01.jpg" width="24"/> 1974</a></p>
<p class="toc"><a href="#/xhtml/Chapter02">use everything <i>in</i> your arsenal <img alt="" class="inline" height="18" src="images/toc02.jpg" width="36"/> 1980</a></p>
<p class="toc"><span href="#/xhtml/Chapter03" title="Link target outside of Sample">lucky <img alt="" class="inline" height="18" src="images/toc03.jpg" width="32"/> 1985</span></p>
<p class="toc"><span href="#/xhtml/Chapter04" title="Link target outside of Sample"><i>the</i> guest room <img alt="" class="inline" height="18" src="images/toc04.jpg" width="32"/> 1986</span></p>
<p class="toc"><span href="#/xhtml/Chapter05" title="Link target outside of Sample"><i>a</i> shift <i>in the</i> weather <img alt="" class="inline" height="18" src="images/toc05.jpg" width="40"/> 1990</span></p>
<p class="toc"><span href="#/xhtml/Chapter06" title="Link target outside of Sample">trees <i>from</i> heaven <img alt="" class="inline" height="18" src="images/toc06.jpg" width="24"/> 2003</span></p>
<p class="toc"><span href="#/xhtml/Chapter07" title="Link target outside of Sample">opportunity cost <img alt="" class="inline" height="18" src="images/toc07.jpg" width="29"/> 2006</span></p>
<p class="toc"><span href="#/xhtml/Chapter08" title="Link target outside of Sample"><i>the</i> vagaries <i>of</i> love <img alt="" class="inline" height="18" src="images/toc08.jpg" width="32"/> 2007</span></p>
<p class="toc"><span href="#/xhtml/Chapter09" title="Link target outside of Sample"><i>in the</i> hermitage <img alt="" class="inline" height="15" src="images/toc09.jpg" width="39"/> 2010</span></p>
<p class="toc"><span href="#/xhtml/Chapter10" title="Link target outside of Sample"><i>in the</i> museum <i>of</i> your life <img alt="" class="inline" height="18" src="images/toc10.jpg" width="32"/> 2011</span></p>
<p class="toc"><span href="#/xhtml/Chapter11" title="Link target outside of Sample">garden <i>for the</i> blind <img alt="" class="inline" height="18" src="images/toc11.jpg" width="27"/> 2014</span></p>
<p class="toc1"><span href="#/xhtml/Acknowledgment" title="Link target outside of Sample"><i>acknowledgments</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?f26422c4